export default function getPixelRatio() {
  let r = 1;

  if (typeof window === "undefined") {
    return r;
  }

  if ("devicePixelRatio" in window) {
    r = window.devicePixelRatio;
  } else if ("matchMedia" in window) {
    if (window.matchMedia("(min-resolution: 3dppx)").matches) {
      r = 3;
    } else if (window.matchMedia("(min-resolution: 2dppx)").matches) {
      r = 2;
    } else if (window.matchMedia("(min-resolution: 1dppx)").matches) {
      r = 1;
    }
  }

  return Math.ceil(r);
}
